<div class="modal show">
	<div class="modal__content">
		<i class="icon-info" style="color: #ffd200; font-size: 5rem"></i>
		<div class="modal__content__body">
			<div class="body__header">
				<h2>{{ 'RECHARGE.WARNING_PHONE_TITLE' | translate }}</h2>
				<span>{{ 'RECHARGE.WARNING_PHONE_SUBTITLE' | translate }}</span>
			</div>
		</div>
		<div class="modal__content__buttons">
			<button class="button" type="button" (click)="dialogRef.close(true)">
				<i class="icon-chevron-left"></i>
				{{ 'GENERAL.GET_BACK' | translate }}
			</button>
		</div>
	</div>
</div>
